import { PplLoadingEllipsisComponent } from './loading-ellipsis.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    PplLoadingEllipsisComponent
  ],
  exports: [
    PplLoadingEllipsisComponent
  ]
})
export class PplLoadingEllipsisModule {
}

export * from './loading-ellipsis.component';
